import "../styles/App.css";
import React from "react";

function Terms() {
  return (
    <div>
		<p>TBD</p>
    </div>
  );
}

export default Terms;
